import { render, staticRenderFns } from "./MultiplePanelComponent.vue?vue&type=template&id=f5f2b524&scoped=true&"
import script from "./MultiplePanelComponent.vue?vue&type=script&lang=js&"
export * from "./MultiplePanelComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePanelComponent.vue?vue&type=style&index=0&id=f5f2b524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f2b524",
  null
  
)

export default component.exports